"use client";

import { saveAs } from "file-saver";
import { FileDown, FileText } from "lucide-react";

const AttachesBlock = ({ data, id }: { data: any; id?: string }) => {
  const { title } = data.file;
  if (!title) return null;

  const fileTitle = data.title || "Attachment";
  const fileSize = data.file?.size
    ? `(${(data.file.size / 1024).toFixed(1)} KB)`
    : "";

  const handleDownload = async () => {
    try {
      const response = await fetch(`/api/file/assets?path=${title}`);
      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      saveAs(blob, fileTitle);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  return (
    <button
      id={id}
      className="editor-attachment w-full"
      onClick={handleDownload}
    >
      <div className="editor-attachment-icon">
        <FileText size={20} />
      </div>
      <div className="editor-attachment-info">
        <span className="editor-attachment-title">{fileTitle}</span>
        {fileSize && <span className="editor-attachment-size">{fileSize}</span>}
      </div>
      <div className="editor-attachment-download">
        <FileDown size={20} />
      </div>
    </button>
  );
};

export default AttachesBlock;
